export const TRAINING_SUPPORTED_ATTACK_TYPES = [
	"Phishing",
	"Smishing",
	"Attachment",
	"QRcode"
];

export function isSimulationTypeAllowed(attackType, simulationType) {
	if (simulationType !== "Simulation Attack + Training") return true;
	if (!attackType) return true;
	return TRAINING_SUPPORTED_ATTACK_TYPES.includes(attackType);
}
